import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './styles.css';

class Slot extends React.Component {
  render() {
    const {
      label,
      value,
      separator,
      verticalSeparator,
      theme,
      empty,
      children,
      small,
      className,
    } = this.props;

    return (
      <div className={classNames('Slot__root', `Slot__theme__${theme}`, className || '', { Slot__separator: separator }, { Slot__verticalSeparator: verticalSeparator })}>
        {!empty &&
          <React.Fragment>
            <span className="Slot__root__value">{value}{small && <small> {small}</small>}</span>
            <span className="Slot__root__label">{label}</span>
          </React.Fragment>
        }
        {empty && children}
      </div>
    );
  }
}

Slot.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  theme: PropTypes.string,
};

Slot.defaultProps = {
  label: 'Missing label',
  value: 'Missing value',
  theme: 'default',
};

export default Slot;
